<template>
    <transition name="el-fade-in">
        <div class="all" v-show="show">
            <div class="title">{{ name || "Exercise" }}</div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/exercise-list' }"
                    >exercise list</el-breadcrumb-item
                >
                <el-breadcrumb-item>{{
                    name || "change exercise"
                }}</el-breadcrumb-item>
            </el-breadcrumb>
            <page-editer
                :modelData.sync="data"
                :render="renderData"
                :handlerSave="Save"
                :handlerDelete="Delete"
                :handleLoad="Loaded"
            ></page-editer>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            show: false,
            renderData: [
                {
                    key: "Name",
                    type: "input",
                    modelName: "title",
                    must: true,
                    maxlength: "50",
                },
                {
                    key: "Description",
                    type: "textarea",
                    modelName: "description",
                    maxlength: "255",
                    must: true,
                },
                {
                    key: "Cover image",
                    type: "image",
                    modelName: "coverImageUrl",
                    must: true,
                },
                {
                    key: "Start video",
                    type: "video",
                    modelName: "videoStartUrl",
                    timeModel: "videoStartDuration",
                },
                {
                    key: "Video",
                    type: "video",
                    modelName: "videoUrl",
                    timeModel: "videoDuration",
                    must: true,
                },
                {
                    key: "End video",
                    type: "video",
                    modelName: "videoEndUrl",
                    timeModel: "videoEndDuration",
                },
                {
                    key: "Voice",
                    type: "audio",
                    modelName: "voiceUrl",
                    must: true,
                },
                {
                    key: "Guide voice",
                    type: "audio",
                    modelName: "guideVoiceUrl",
                    must: true,
                },
                {
                    key: "Guide voice text",
                    type: "textarea",
                    modelName: "guideVoiceText",
                    maxlength: "255",
                    must: true,
                },
                {
                    key: "Script",
                    type: "select",
                    modelName: "audioTextId",
                    options: [],
                    must: true,
                },
                {
                    key: "Repeat times /secs",
                    type: "input",
                    modelName: "repeatTimes",
                    must: true,
                    format: "[^0-9]",
                    maxlength: 2,
                },
                {
                    key: "Exercise Total Time",
                    type: "computed",
                    computedFunc(templateData) {
                        // 判断计算类型
                        let time = 0;
                        switch (templateData["audioType"]) {
                            // 按次数
                            case 2: {
                                time =
                                    templateData["videoStartDuration"] +
                                    templateData["videoDuration"] *
                                        templateData["repeatTimes"] +
                                    templateData["videoEndDuration"];
                                break;
                            }
                            // 按时长
                            case 3: {
                                let startAndEndTime =
                                    templateData["videoStartDuration"] +
                                    templateData["videoEndDuration"];
                                let Alltime = templateData["repeatTimes"];
                                // 可用时间 = 总时间-开头结尾时间
                                let useTime = Alltime * 1000 - startAndEndTime;
                                time += startAndEndTime;
                                if (useTime > templateData["videoDuration"]) {
                                    let sum =
                                        useTime / templateData["videoDuration"];
                                    if (
                                        useTime %
                                            templateData["videoDuration"] >
                                        0
                                    ) {
                                        sum++;
                                    }
                                    time += sum * templateData["videoDuration"];
                                } else {
                                    time += templateData["videoDuration"];
                                }
                                break;
                            }
                        }
                        return parseInt(time);
                    },
                    blodKey: true,
                },
                {
                    key: "Focus areas",
                    type: "selects",
                    modelName: "focusArea",
                    options: this.$store.state.optionBase.focusArea,
                    uploadLabel: true,
                    must: true,
                },
                {
                    key: "Goals",
                    type: "selects",
                    modelName: "goals",
                    options: [{ label: "Anti-aging", value: 1 }],
                    uploadLabel: true,
                    disabled: true,
                },
                {
                    key: "Equipments",
                    type: "selects",
                    modelName: "equipments",
                    options: [
                        { label: "cream", value: 1 },
                        { label: "essential oil", value: 2 },
                    ],
                    uploadLabel: true,
                    disabled: true,
                },
                {
                    key: "Difficulty",
                    type: "select",
                    modelName: "difficulty",
                    options: [
                        { label: "Beginner", value: 1 },
                        { label: "Advance", value: 2 },
                    ],
                    uploadLabel: true,
                    disabled: true,
                },
                {
                    key: "Special needs",
                    type: "selects",
                    modelName: "specialNeeds",
                    options: [
                        { label: "Acnes", value: 1 },
                        { label: "Scars", value: 2 },
                    ],
                    uploadLabel: true,
                    disabled: true,
                },
                {
                    key: "Skin type",
                    type: "select",
                    modelName: "skinType",
                    options: [{ label: "Oli", value: 1 }],
                    uploadLabel: true,
                    disabled: true,
                },
            ],
            data: {
                name: "",
                description: "",
            },
        };
    },
    methods: {
        Save() {
            let uploadData = this.$deepCopy(this.data);
            this.renderData.some((item) => {
                // 多选数组转字符串数组
                if (item.type === "selects" && this.data[item.modelName]) {
                    uploadData[item.modelName] = this.data[item.modelName].toString();
                }
            });
            this.$request("/manage/exercise/save", uploadData, (res) => {
                if (res.data.code === 200) {
                    this.$message({
                        message: "save success",
                        type: "success",
                    });
                    this.$router.push("/exercise-list");
                }
            });
        },
        Delete() {
            this.$confirm("Confirm delete？", "", { type: "warning" }).then(
                () => {
                    this.$request(
                        `/manage/exercise/del/${this.$route.query.id}`,
                        {},
                        (res) => {
                            if (res.data.code === 200) {
                                this.$message({
                                    message: "delete success",
                                    type: "success",
                                });
                                this.$router.go(-1);
                            }
                        }
                    );
                }
            );
        },
        Loaded() {
            this.show = true;
            if (this.$route.query.id && this.$route.query.id != "add") {
                this.$request(
                    `/manage/exercise/detail/${this.$route.query.id}`,
                    {},
                    (res) => {
                        let data = res.data.data;
                        this.renderData.some((item) => {
                            if (item.type === "selects" && data[item.modelName]) {
                                data[item.modelName] = data[item.modelName].split(",");
                            }
                        });
                        this.data = data;
                    },
                    "get",
                    true
                );
            }
            // 获取exercise的使用音频 导入进 render
            this.$request("/manage/adoText/listExcUse", {}, (res) => {
                if (res.data.code === 200) {
                    res.data.data.some((item) => {
                        item.value = item.id;
                        item.label = item.audioText;
                    });
                    this.renderData.some((item) => {
                        if (item.modelName === "audioTextId") {
                            item.options = res.data.data;
                        }
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
.all {
    box-sizing: border-box;
    padding: 0 40px;
    text-align: left;
    font-size: 13px;
    margin-top: 30px;
}
.title {
    font-size: 24px;
    line-height: 50px;
}
.el-breadcrumb {
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
}
/* .kuai-con .el-input >>> input
{
    font-size: 13px;
    height: 27px;
} */
</style>